.ck{max-width:100%;}